export class CartItem {
    productName: string;
    productQuantities: string;
    productTotal: number;
}